import type { FormControlProps } from 'rsuite'

import React from 'react'
import { Input, Form } from 'rsuite'

export const Textarea = React.forwardRef<HTMLTextAreaElement>((props, ref) => (
  <Input {...props} as="textarea" ref={ref} />
))

const FormTextareaControl: React.FC<FormControlProps & { rows?: number }> = (
  props
) => <Form.Control {...props} accepter={Textarea} />

export default FormTextareaControl
